import { Component, h } from '@stencil/core';

@Component({
  tag: 'loading-component',
  styleUrl: 'loading-component.css',
  shadow: false,
})
export class LoadingComponent {
  render() {
    return (
      <div class="loading-container-flex d-flex flex-column justify-content-center aling-items-center mt-5">
        <div class="container text-center">
          <div class="col mt-3 ">
            <span class="loader"></span>
            <p class="mt-3 fw-medium color-text-loading">
              Cargando contenido... <br />
              Espere un momento por favor.
            </p>
          </div>
        </div>
      </div>
    );
  }
}
